import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ArrowUpRight } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen bg-[#F7F5F2] text-[#1A1A1A] flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center">
        <div className="max-w-[920px] mx-auto px-6 md:px-10 py-24 md:py-32 text-center">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="h-px w-8 bg-[#1FA5B8]" />
            <span className="text-[11px] uppercase tracking-[0.32em] text-[#1FA5B8] font-body">
              404 · A quiet wrong turn
            </span>
            <span className="h-px w-8 bg-[#1FA5B8]" />
          </div>
          <h1 className="font-display tracking-tight leading-[1] text-[clamp(3rem,7vw,6rem)] font-medium">
            This page is <br />
            <span className="italic font-light">not here</span>.
          </h1>
          <p className="mt-8 font-body text-[#5C5C5C] text-lg leading-[1.8] max-w-xl mx-auto">
            Maybe it moved, maybe it never existed. Either way, the rest of
            the work is still waiting just one click away.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              data-testid="nf-home"
              className="inline-flex items-center gap-2 bg-[#1A1A1A] hover:bg-[#1FA5B8] text-[#F7F5F2] font-body text-[12px] uppercase tracking-[0.22em] h-11 px-5 transition-colors"
            >
              Return to the Academy
              <ArrowUpRight size={14} strokeWidth={1.6} />
            </Link>
            <Link
              to="/work-with-me"
              data-testid="nf-wwm"
              className="inline-flex items-center gap-2 border border-[#1A1A1A] hover:border-[#1FA5B8] hover:text-[#1FA5B8] text-[#1A1A1A] font-body text-[12px] uppercase tracking-[0.22em] h-11 px-5 transition-colors"
            >
              Or work with me
              <ArrowUpRight size={14} strokeWidth={1.6} />
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
